<div class="table-container">
  <table mat-table [dataSource]="loading ? skeletonData : dataSource" matSort (matSortChange)="onSortChange($event)"
    class="mat-elevation-z8">

    <!-- Dynamic columns -->
    <ng-container *ngFor="let column of displayedColumns" [matColumnDef]="column">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ getColumnConfig(column)?.header | translate }}
      </th>
      <td mat-cell *matCellDef="let element" class="p-2" [class.clickable]="getColumnConfig(column)?.onClick"
        (click)="onCellClick($event, element, getColumnConfig(column)!)">

        <!-- Loading skeleton -->
        <div *ngIf="loading" class="skeleton-text"></div>

        <!-- Actual content -->
        <ng-container *ngIf="!loading">
          <!-- Icon template -->
          <mat-icon *ngIf="getColumnConfig(column)?.customTemplate === 'icon' && getColumnConfig(column)?.onClick"
            class="action-icon">
            arrow_forward_ios
          </mat-icon>

          <!-- Currency template -->
          <span *ngIf="getColumnConfig(column)?.customTemplate === 'currency'">
            {{ getCellValue(element, column) | currency:'EUR' }}
          </span>

          <!-- Date template -->
          <span *ngIf="getColumnConfig(column)?.customTemplate === 'date'">
            {{ getCellValue(element, column) | date:'dd.MM.yyyy' }}
          </span>

          <!-- WeekDay template -->
          <span *ngIf="getColumnConfig(column)?.customTemplate === 'weekDay'">
            {{ getCellValue(element, column) | weekDay }}
          </span>

          <div class="badge" [ngClass]="getCellValue(element, column)"
            *ngIf="getColumnConfig(column)?.customTemplate === 'status'">
            <span>
              {{ '@T.COMMON.STATUS.'+getCellValue(element, column).toUpperCase() | translate }}
            </span>
          </div>

          <!-- Default template -->
          <span *ngIf="!getColumnConfig(column)?.customTemplate">
            {{ getCellValue(element, column) }}
          </span>
        </ng-container>
      </td>
    </ng-container>

    <!-- Header row -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

    <!-- Data rows -->
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <!-- No data row -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell no-data" [attr.colspan]="displayedColumns.length">
        <div *ngIf="!loading" class="no-data-message">
          No data available
        </div>
      </td>
    </tr>
  </table>

  <!-- Pagination -->
  <mat-paginator *ngIf="showPagination" [length]="totalCount" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
    (page)="onPageChange($event)" showFirstLastButtons>
  </mat-paginator>
</div>
